import React, { useEffect, useState } from 'react';
import { RotatingBanner } from '../../components/RotatingBanner';
import { dataPorExtenso } from '../../pages/PhotoGallery/dados';
import { useStartupState } from '../../Providers/StartupState';
import { handleGetData } from '../../Api';
import * as S from './style';
import { NavLink } from 'react-router-dom';

export const LatestNews = ({ slides, BGColor }) => {
  const [screenWidth, setScreenWidth] = React.useState();
  const [noticias, setNoticias] = useState([]);

  const { token } = useStartupState();

  useEffect(() => {
    if (token) {
      handleGetData(
        token,
        // "Últimas notícias" precisa de ordem explícita, senão vem o que o
        // Squidex devolver primeiro -- que não é necessariamente o mais novo.
        `api/content/copasul/materia/?$orderby=data/data/iv desc&$top=3`,
        { 'X-Fields': 'titulo,data,resumo,endereco' },
      )
        .then((response) => {
          setNoticias(response?.data?.items);
          if (response?.status !== 200) {
            throw new Error(response.message);
          }
        })
        .catch((e) => {
          setNoticias([]);
          console.log(e.message);
        });
    }
  }, [token]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 799) {
        return setScreenWidth(1);
      } else if (window.innerWidth >= 799 && window.innerWidth <= 1099) {
        return setScreenWidth(2);
      } else if (window.innerWidth > 1099) {
        return setScreenWidth(3);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  return (
    <S.SlidesBox BGColor={BGColor}>
      <S.RotatingBannerBox>
        <p className="title">Últimas Notícias relacionadas - copasul</p>
        <RotatingBanner slidesToShow={screenWidth} slidesToScroll={screenWidth}>
          {noticias &&
            noticias.map((item) => (
              <div key={item?.id} style={{ padding: '0 1rem' }}>
                <S.SubRotatingBanner>
                  <S.RotatingBannercontent>
                    <span>
                      {dataPorExtenso(item?.data?.data?.iv)}
                    </span>
                    <p>{item?.data?.resumo?.iv || item?.data?.titulo?.iv}</p>
                    <NavLink to={`/noticias/${item?.data?.endereco?.iv}`}>
                      Leia mais...
                    </NavLink>
                  </S.RotatingBannercontent>
                </S.SubRotatingBanner>
              </div>
            ))}
        </RotatingBanner>
      </S.RotatingBannerBox>
    </S.SlidesBox>
  );
};
